// Atelier — Virtual Try-On · © 2026 Atelier. All rights reserved.
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Nav from "./components/Nav";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Studio from "./pages/Studio";
import Wardrobe from "./pages/Wardrobe";
import Outfits from "./pages/Outfits";
import Compare from "./pages/Compare";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import PublicOutfit from "./pages/PublicOutfit";
import Profile from "./pages/Profile";
import Discover from "./pages/Discover";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Admin from "./pages/Admin";
import Digest from "./pages/Digest";
import { Privacy, Terms } from "./pages/Legal";
import "./App.css";

const Private = ({ children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-20 font-mono-eyebrow text-center">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace/>;
  return children;
};

const Shell = () => (
  <div className="min-h-screen relative">
    <Nav/>
    <Routes>
      <Route path="/" element={<Landing/>}/>
      <Route path="/auth" element={<Auth/>}/>
      <Route path="/forgot-password" element={<ForgotPassword/>}/>
      <Route path="/reset-password" element={<ResetPassword/>}/>
      <Route path="/pricing" element={<Pricing/>}/>
      <Route path="/billing/success" element={<BillingSuccess/>}/>
      <Route path="/discover" element={<Discover/>}/>
      <Route path="/studio" element={<Private><Studio/></Private>}/>
      <Route path="/wardrobe" element={<Private><Wardrobe/></Private>}/>
      <Route path="/outfits" element={<Private><Outfits/></Private>}/>
      <Route path="/compare" element={<Private><Compare/></Private>}/>
      <Route path="/digest" element={<Private><Digest/></Private>}/>
      <Route path="/profile" element={<Private><Profile/></Private>}/>
      <Route path="/admin" element={<Private><Admin/></Private>}/>
      <Route path="/outfits/:slug" element={<PublicOutfit/>}/>
      <Route path="/privacy" element={<Privacy/>}/>
      <Route path="/terms" element={<Terms/>}/>
    </Routes>
    <Toaster position="bottom-right" toastOptions={{ className: "font-mono-eyebrow" }}/>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell/>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
